"use client";
import { jsx as e, jsxs as B } from "react/jsx-runtime";
import { cva as p } from "class-variance-authority";
import { forwardRef as k, useState as N } from "react";
import { twMerge as T } from "tailwind-merge";
import { cn as o } from "./index.es10.js";
import { Text as y } from "./index.es4.js";
const m = p(
  `
    px-6
    rounded-sm
    focus-visible:outline-2
    focus-visible:outline-blue-600
    focus-visible:outline-offset-2
    cursor-pointer
    text-center
    border-transparent
    border-2
    flex
    items-center
    gap-x-2
`,
  {
    variants: {
      variant: {
        primary: "bg-yellow-400 hover:bg-yellow-600 text-gray-900",
        secondary: "bg-gray-800 hover:bg-gray-900 text-white",
        "outlined-dark": "border-gray-800 text-gray-800 hover:bg-gray-900 hover:text-white",
        "outlined-light": "border-white text-white hover:text-gray-800 hover:bg-white hover:border-gray-800",
        text: "bg-transparent text-blue-700 hover:bg-gray-100 hover:text-blue-800",
        alternate: "bg-blue-700 hover:bg-blue-800 text-white"
      },
      size: {
        default: "py-1-5 min-h-[40px]",
        large: "py-3 min-h-[56px]"
      },
      disabled: {
        true: "bg-gray-200 text-gray-500 border-gray-200 hover:border-gray-200 focus:outline-none hover:bg-gray-200 hover:text-gray-500 cursor-not-allowed"
      },
      isLink: {
        true: "inline-flex items-center"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), x = p("w-4 h-4 fill-current hover:fill-current", {
  variants: {
    variant: {
      primary: "fill-current hover:fill-current",
      secondary: "fill-white hover:fill-gray-900",
      "outlined-dark": "fill-gray-800 hover:fill-white",
      "outlined-light": "fill-current hover:fill-current",
      text: "fill-current hover:fill-current",
      alternate: "fill-white hover:fill-gray-200"
    },
    disabled: {
      true: "fill-gray-500 hover:fill-gray-500"
    }
  }
}), I = k(
  ({
    children: n,
    variant: t,
    className: a = "",
    size: i = "default",
    disabled: r = !1,
    href: s,
    iconPrefix: u,
    iconSuffix: c,
    ...h
  }, f) => {
    const g = i === "large" ? "base" : "sm", [w, d] = N(!1), b = (F) => {
      F.currentTarget.matches(":focus-visible") && d(!0);
    }, v = () => d(!1);
    let l;
    return s && !r ? l = /* @__PURE__ */ e(
      "a",
      {
        ...h,
        ref: f,
        className: o(m({ variant: t, size: i, disabled: r, className: a, isLink: !0 })),
        href: s,
        onFocus: b,
        onBlur: v,
        children: /* @__PURE__ */ e(y, { asChild: !0, fontSize: g, children: /* @__PURE__ */ e("span", { children: n }) })
      }
    ) : l = /* @__PURE__ */ B(
      "button",
      {
        ...h,
        ref: f,
        className: o(m({ variant: t, size: i, disabled: r, className: a })),
        disabled: r,
        onFocus: b,
        onBlur: v,
        children: [
          u && /* @__PURE__ */ e("div", { className: o(x({ variant: t, disabled: r })), children: u }),
          /* @__PURE__ */ e(y, { asChild: !0, fontSize: g, children: /* @__PURE__ */ e("span", { children: n }) }),
          c && /* @__PURE__ */ e("div", { className: o(x({ variant: t, disabled: r })), children: c })
        ]
      }
    ), /* @__PURE__ */ e(
      "div",
      {
        className: T(
          "inline-block rounded-sm",
          w && "focus-within:outline-2 focus-within:outline-white focus-within:outline-offset-4"
        ),
        children: l
      }
    );
  }
);
export {
  I as Button
};
